import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import styles from './choice.css';
import Icon from '../icon';

class Choice extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            checked: this.props.checked
        };
        this.changeState = this.changeState.bind(this);
    }
    changeState (e) {
        if (this.props.type === 'radio' && this.props.onChange) {
            this.props.onChange(e.target.value, e);
            this.setState({checked: this.props.checked});
        } else if (this.props.type === 'checkbox' && this.props.onChange) {
            this.props.onChange(e.target.value, e);
            this.setState({checked: !this.state.checked});
        } else {
            this.setState({checked: !this.state.checked});
        }
    }

    UNSAFE_componentWillReceiveProps(newProps){
        this.setState(newProps);
    }

    render () {
        const {
            checked,
            children,
            className,
            labelClassname,
            disabled,
            iconSize,
            iconType,
            name,
            onChange,
            reverse,
            type,
            uuid,
            useSprite,
            value,
            ...otherProps } = this.props;

        const inputProps = {}
        const divProps = {};
        for(var key in otherProps) {
            if(key.indexOf("aria") !== -1) {
                inputProps[key] = otherProps[key];
            } else {
                divProps[key] = otherProps[key];
            }
        };

        const label = this.props.label || children;

        const textcolor = disabled ? 'gray-light-1' : 'primary-dark';
        const labeltextClass = cx(styles.labeltext, {
            [`${styles.labeltextDisabled}`]: disabled
        }, labelClassname);
        const iconClass = cx(styles.easeTransition, {
            'opacity0': type === 'radio' ? !this.props.checked : !this.state.checked
        });
        const elementClass = cx(className, 'i-flex align-item-center');
        const tabindex = disabled ? '-1' : '0';
        const spanClass = type === 'radio'
            ? cx(styles.spanClass, styles.radioClass)
            : cx(styles.spanClass, 'bdr-rad4');

        const childArray = [
            <label htmlFor={uuid} key={type} className="i-flex">
                <input
                    tabIndex={tabindex}
                    className="opacity0 absolute"
                    type={type}
                    name={name}
                    disabled={disabled}
                    id={uuid}
                    onChange={this.changeState}
                    checked={type === 'radio' ? this.props.checked : this.state.checked}
                    value={value}
                    {...inputProps}
                />
                <span className={spanClass}>
					<Icon name={iconType} color={textcolor} width={iconSize} height={iconSize} className={iconClass} useSprite={useSprite} />
				</span>
            </label>,
            <label key="label" htmlFor={uuid} className={labeltextClass}>{label}</label>
        ];
        return (
            <div className={elementClass} {...divProps}>
                {label ? (reverse ? childArray.reverse() : childArray) : childArray[0]}
            </div>
        );
    }
}

Choice.propTypes = {
    checked: PropTypes.bool,
    children: PropTypes.node,
    className: PropTypes.string,
    labelClassname: PropTypes.string,
    disabled: PropTypes.bool,
    useSprite: PropTypes.bool,
    iconSize: PropTypes.string,
    iconType: PropTypes.string,
    label: PropTypes.string,
    name: PropTypes.string,
    reverse: PropTypes.bool,
    type: PropTypes.string.isRequired,
    uuid: PropTypes.string.isRequired,
    value: PropTypes.string,
    onChange: PropTypes.func
};

Choice.defaultProps = {
    children: null,
    className: '',
    labelClassname: '',
    disabled: false,
    useSprite: false,
    checked: false,
    iconSize: '1em',
    iconType: '',
    label: '',
    name: '',
    reverse: false,
    value: '',
    onChange: null
};

export default Choice;
